__turbopack_context__.v({
  "button": "_2aXA5a_button",
  "description": "_2aXA5a_description",
  "descriptionAccent": "_2aXA5a_descriptionAccent",
});
